export const SummarySelectors = {
	summary: 'summary',
	pieChart: 'summary-pie-chart',
	closeButton: 'close-button',
	testDetailsButton: 'test-details-button',
	testHistoryButton: 'test-history-button',
	flashCardsButton: 'flash-cards-button',
	simpleView: 'simple-panel',
};
